import { render } from "./NotifyChannelsModal.vue?vue&type=template&id=b2e868ee&scoped=true"
import script from "./NotifyChannelsModal.vue?vue&type=script&lang=js"
export * from "./NotifyChannelsModal.vue?vue&type=script&lang=js"

import "./NotifyChannelsModal.vue?vue&type=style&index=0&id=b2e868ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e868ee"]])

export default __exports__